import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate, ICrudGetAction } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { IRootState } from 'app/shared/reducers';
import { getEntity } from './asset-use.reducer';
import { IAssetUse } from 'app/shared/model/asset-use.model';
import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';

export interface IAssetUseDetailProps extends StateProps, DispatchProps, RouteComponentProps<{ id: string }> {}

export const AssetUseDetail = (props: IAssetUseDetailProps) => {
  useEffect(() => {
    props.getEntity(props.match.params.id);
  }, []);

  const { assetUseEntity } = props;
  return (
    <Row className="justify-content-center card-title">
      <Col md="8">
        <h2>
          <Translate contentKey="assetApp.assetUse.detail.title">AssetUse</Translate> [<b>{assetUseEntity.id}</b>]
        </h2>
        <dl className="jh-entity-details card-content">
          <dt>
            <span id="identifier">
              <Translate contentKey="assetApp.assetUse.identifier">Identifier</Translate>
            </span>
          </dt>
          <dd>{assetUseEntity.identifier}</dd>
          <dt>
            <span id="description">
              <Translate contentKey="assetApp.assetUse.description">Description</Translate>
            </span>
          </dt>
          <dd>{assetUseEntity.description}</dd>
          <dt>
            <Translate contentKey="assetApp.assetUse.provider">Provider</Translate>
          </dt>
          <dd>{assetUseEntity.providerId ? assetUseEntity.providerId : ''}</dd>
        </dl>
        <Button tag={Link} onClick={props.history.goBack} replace color="info">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/asset-use/${assetUseEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

const mapStateToProps = ({ assetUse }: IRootState) => ({
  assetUseEntity: assetUse.entity,
});

const mapDispatchToProps = { getEntity };

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(mapStateToProps, mapDispatchToProps)(AssetUseDetail);
